var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7551 14.2362H7.48426L17.6509 4.06954C18.4634 3.25704 18.4634 1.92371 17.6509 1.11121C17.4582 0.918079 17.2293 0.764854 16.9772 0.66031C16.7252 0.555765 16.455 0.501953 16.1822 0.501953C15.9093 0.501953 15.6392 0.555765 15.3871 0.66031C15.1351 0.764854 14.9062 0.918079 14.7134 1.11121L0.984259 14.8404C0.791126 15.0331 0.637902 15.262 0.533358 15.5141C0.428813 15.7661 0.375 16.0363 0.375 16.3091C0.375 16.582 0.428813 16.8521 0.533358 17.1042C0.637902 17.3562 0.791126 17.5851 0.984259 17.7779L14.7134 31.507C14.9063 31.6999 15.1353 31.8529 15.3873 31.9573C15.6393 32.0617 15.9094 32.1154 16.1822 32.1154C16.4549 32.1154 16.725 32.0617 16.9771 31.9573C17.2291 31.8529 17.458 31.6999 17.6509 31.507C17.8438 31.3142 17.9968 31.0852 18.1012 30.8332C18.2056 30.5812 18.2593 30.3111 18.2593 30.0383C18.2593 29.7655 18.2056 29.4954 18.1012 29.2434C17.9968 28.9914 17.8438 28.7624 17.6509 28.5695L7.48426 18.4029H30.7551C31.9009 18.4029 32.8384 17.4654 32.8384 16.3195C32.8384 15.1737 31.9009 14.2362 30.7551 14.2362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.c3fcbf009e07f51d9ca55b1cba4ac987.svg";
export { ForwardRef as ReactComponent };